import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

interface UseCombinedAvatarErrorsResult {
    errors: Error[];
    hasErrors: boolean;
    setMicError: Dispatch<SetStateAction<Error | null>>;
    setParseError: Dispatch<SetStateAction<Error | null>>;
    setWsError: Dispatch<SetStateAction<Error | null>>;
    setSpeechError: Dispatch<SetStateAction<Error | null>>;
    setAudioInitError: Dispatch<SetStateAction<Error | null>>;
}

interface UseCombinedAvatarErrorsProps {
    connectionDataError: Error | null;
    chatError: Error | null;
}

export const useCombinedAvatarErrors = ({
    connectionDataError,
    chatError,
}: UseCombinedAvatarErrorsProps): UseCombinedAvatarErrorsResult => {
    const [errors, setErrors] = useState<Error[]>([]);
    const [micError, setMicError] = useState<Error | null>(null);
    const [parseError, setParseError] = useState<Error | null>(null);
    const [wsError, setWsError] = useState<Error | null>(null);
    const [speechError, setSpeechError] = useState<Error | null>(null);
    const [audioInitError, setAudioInitError] = useState<Error | null>(null);

    useEffect(() => {
        const errorsList = [
            connectionDataError,
            chatError,
            micError,
            parseError,
            wsError,
            speechError,
            audioInitError,
        ];

        setErrors(errorsList.filter((error) => error !== null));
    }, [
        chatError,
        connectionDataError,
        micError,
        parseError,
        wsError,
        speechError,
        audioInitError,
    ]);

    const hasErrors = errors.length > 0;

    return {
        errors,
        hasErrors,
        setMicError,
        setParseError,
        setWsError,
        setSpeechError,
        setAudioInitError,
    };
};
